module.exports = __webpack_public_path__ + "static/media/GS_steps_3.906e4c3e.jpg";